module.exports = __webpack_public_path__ + "img/s2_stepimg02.183d384d.png";